// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"modalWrapper--m2xn_","buttonWrapper":"buttonWrapper--27XTR","contentWrapper":"contentWrapper--2VJj7"};